<rkt-table
  class="funds-on-hold-list-table"
  [rows]="fundsOnHold"
  [columns]="columns"
  [limit]="10"
  [count]="totalElements"
  (fetchData)="getFundsOnHold($event)"
  [loadingIndicator]="isLoading"
  [offset]="activePage"
  [rowHeight]="64"
  [isItemsAlignCenter]="true"
  [messages]="{ emptyMessage: emptyListMessage }"
  emptyValuePlaceholder="--"
  dateTimeFormat="MM/dd/yy HH:mm"
  (rowActivated)="onRowClick($event)"
  [sortParam]="sortParams"
></rkt-table>
